import LoadingIcon from "../LoadingIcon";

export default function VerifyingPage() {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <LoadingIcon icon="three-dots" className="w-10" />
    </div>
  );
}
